import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

// this is optimistic pending segments store for atlas doris.
export interface OptimisticPendingSegmentsState {
  // optimistic pending segments STATE
  optimisticPendingSegments: Set<string>;

  // optimistic pending segments ACTIONS
  addOptimisticPendingSegment: (segmentId: string) => void;
  removeOptimisticPendingSegment: (segmentId: string) => void;
  clearOptimisticPendingSegments: () => void;

  // Selectors
  isOptimisticallyPending: (segmentId: string) => boolean;
  getOptimisticPendingSegmentIds: () => string[];
}

/**
 * Zustand store for managing segments that should appear as pending
 * immediately after creation, before the API confirms their processing status
 */
export const useOptimisticPendingSegmentsStore = create<OptimisticPendingSegmentsState>()(
  devtools(
    (set, get) => ({
      // Initial state
      optimisticPendingSegments: new Set<string>(),

      // Actions
      addOptimisticPendingSegment: (segmentId: string) => {
        set((state) => ({
          optimisticPendingSegments: new Set(state.optimisticPendingSegments).add(segmentId)
        }));
      },

      removeOptimisticPendingSegment: (segmentId: string) => {
        set((state) => {
          const newSet = new Set(state.optimisticPendingSegments);
          newSet.delete(segmentId);
          return { optimisticPendingSegments: newSet };
        });
      },

      clearOptimisticPendingSegments: () => {
        set({ optimisticPendingSegments: new Set<string>() });
      },

      // Selectors
      isOptimisticallyPending: (segmentId: string) => {
        return get().optimisticPendingSegments.has(segmentId);
      },

      getOptimisticPendingSegmentIds: () => {
        return Array.from(get().optimisticPendingSegments);
      }
    }),
    { name: 'optimistic-pending-segments-store' }
  )
);
